/*
 *  DIGITALX LABS(PVT)LTD PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * 
 *  Copyright © 2019. DIGITALX LABS(PVT)LTD
 *  All Rights Reserved.
 * 
 *  NOTICE:  All information contained herein is, and remains
 *  the property of DIGITALX LABS(PVT)LTD.  The intellectual and technical concepts contained
 *  herein are proprietary to DIGITALX LABS(PVT)LTD.
 *  Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  is strictly forbidden unless prior written permission is obtained from DIGITALX LABS(PVT)LTD.
 */

import React, { Component } from 'react';
import reduxDialog, { closeDialog, openDialog } from 'redux-reactstrap-modal';
import { connect } from "react-redux";
import { compose } from 'recompose';
import { bindActionCreators } from "redux";
import { API_ROOT_URL, MODALS, EVENTS } from '../config/';
import NotificationBarModal from './NotificationBarModal';

import { enterNIC, mobileNoUpdate, showNotificationModal, clearNotification } from "../actions/index";
import {
    translate,
    getLanguage
} from 'react-switch-lang';
import { dataPush } from '../utils/piwikDataLayerPush';
import { last } from 'lodash';
class NICModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            first_name: "",
            last_name: "",
            email: "",
            nic: "",
            city: ""
        }

        this.updateInput = this.updateInput.bind(this);
    }


    updateInput(event) {
        this.setState({[event.target.name]: event.target.value });
    }

    userNICSave() {
        const { event, data } = this.props.nextEvent;
        const { t } = this.props;

        if (!this.state.first_name.trim()) {
            this.props.showNotificationModal({
                type: 'danger',
                message: t("sign_up.enter_first_name")
            });
            return;
        }
        
        if (!this.state.last_name.trim()) {
            this.props.showNotificationModal({
                type: 'danger',
                message: t("sign_up.enter_last_name")
            });
            return;
        }
        
        if (!this.state.email.trim()) {
            this.props.showNotificationModal({
                type: 'danger',
                message: t("sign_up.enter_email")
            });
            return;
        }
        
        if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(this.state.email)
        ) {
            this.props.showNotificationModal({
                type: 'danger',
                message: t("sign_up.invalid_email")
            });
            return;
        }

        if (!this.state.city) {
            this.props.showNotificationModal({
                type: 'danger',
                message: "Please select your city"
            });
            return;
        }

        if (this.state.nic !== "") {

            if (/^([0-9]{9}[x|X|v|V]|[0-9]{12})$/.test(this.state.nic)) {
                // data.nic_number = this.state.nic;
                this.props.enterNIC({
                    first_name: this.state.first_name.trim(),
                    last_name: this.state.last_name.trim(),
                    email: this.state.email.trim().toLowerCase(),
                    nic: this.state.nic.trim(),
                    city: this.state.city
                });

                // piwik pro related code segment
                let dataLayerObject = {
                    event: "enterNIC"
                };
                dataPush(dataLayerObject);
            }
            else {
                var dataModal = { type: 'danger', message: t("sign_up.invalid_nic") }
                this.props.showNotificationModal(dataModal);
            }            

        } else {
            var dataModal = { type: 'danger', message: t("sign_up.enter_nic") }
            this.props.showNotificationModal(dataModal);
        }


    }

    render() {
        const { t } = this.props;

        return (
            <div className="p-2">
                <div className="modal-header">
                <h5 className="modal-title">
                    {t("sign_up.customer_details")}
                </h5>
                    <button type="button" className="close" onClick={() => {
                        this.props.clearNotification();
                        this.props.closeDialog(MODALS.NIC);
                    }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <NotificationBarModal />

                    {/* First Name */}
<div className="mb-3">
    <input
        type="text"
        className="form-control"
        name="first_name"
        placeholder={t("sign_up.first_name")}
        value={this.state.first_name}
        onChange={this.updateInput}
    />
</div>

{/* Last Name */}
<div className="mb-3">
    <input
        type="text"
        className="form-control"
        name="last_name"
        placeholder={t("sign_up.last_name")}
        value={this.state.last_name}
        onChange={this.updateInput}
    />
</div>

{/* Email */}
<div className="mb-3">
    <input
        type="email"
        className="form-control"
        name="email"
        placeholder={t("sign_up.email")}
        value={this.state.email}
        onChange={this.updateInput}
    />
</div>

{/* NIC */}
<div className="mb-3">
    <input
        type="text"
        className="form-control"
        name="nic"
        placeholder={t("sign_up.nic_no")}
        value={this.state.nic}
        onChange={this.updateInput}
    />
</div>

                    {/* City */}
                    <div className="mb-3">
                        <select
                            className="form-control"
                            name="city"
                            value={this.state.city}
                            onChange={this.updateInput}
                        >
                            <option value="">Select your City</option>
                            <option value="Colombo">Colombo</option>
                            <option value="Gampaha">Gampaha</option>
                            <option value="Kalutara">Kalutara</option>
                            <option value="Kandy">Kandy</option>
                            <option value="Matale">Matale</option>
                            <option value="Nuwara Eliya">Nuwara Eliya</option>
                            <option value="Galle">Galle</option>
                            <option value="Matara">Matara</option>
                            <option value="Hambantota">Hambantota</option>
                            <option value="Jaffna">Jaffna</option>
                            <option value="Kilinochchi">Kilinochchi</option>
                            <option value="Mannar">Mannar</option>
                            <option value="Vavuniya">Vavuniya</option>
                            <option value="Mullaitivu">Mullaitivu</option>
                            <option value="Batticaloa">Batticaloa</option>
                            <option value="Ampara">Ampara</option>
                            <option value="Trincomalee">Trincomalee</option>
                            <option value="Kurunegala">Kurunegala</option>
                            <option value="Puttalam">Puttalam</option>
                            <option value="Anuradhapura">Anuradhapura</option>
                            <option value="Polonnaruwa">Polonnaruwa</option>
                            <option value="Badulla">Badulla</option>
                            <option value="Moneragala">Moneragala</option>
                            <option value="Ratnapura">Ratnapura</option>
                            <option value="Kegalle">Kegalle</option>
                        </select>
                    </div>

                    <div className="pt-3">
                        <button type="submit" className="btn btn-primary btn-block"
                            onClick={() => this.userNICSave()}>{t("sign_up.proceed")}
                        </button>
                    </div>


                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return state;
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ clearNotification, closeDialog, openDialog, enterNIC, mobileNoUpdate, showNotificationModal }, dispatch);
}

export default translate(compose(reduxDialog({
    name: 'MODAL_NIC',
    centered: true
}), connect(mapStateToProps, mapDispatchToProps))(NICModal));
